import st from "@/styles/Ui.module.scss";
import ModalLayout from "@/ui/modals/ModalLayout.tsx";
import {useEffect, useRef, useState} from "react";
import eventEmitter from "@/utils/event_emmiter_instance.ts";
import CommonClass from "@/utils/common.ts";
import CreditInfo from "@/types_and_interfaces/credit_info_interface.ts";
import useLoans from "@/hooks/loans.ts";
import {useAtom} from "jotai/index";
import { calculator_product } from "@/atoms/common.ts";
import ProductInterface from "@/types_and_interfaces/product_interface.ts";
import {CircularProgress} from "@mui/joy";



const CreditInfoModal = () => {
    
    const [info, setInf] = useState<CreditInfo | {}>({})
    const [grid, set_grid] = useState<string>("")
    const effect_ran = useRef<boolean>(false)
    const [product] = useAtom(calculator_product)
    const data = info as CreditInfo
    const loans = useLoans()
    const open = (info.hasOwnProperty("title") && info.hasOwnProperty("content"))
    
    const openModal = (x:CreditInfo) => {
        setInf(x)
    }

    const schedule_handle = async () => {
        
        if(typeof product !== "object") return
        const obj:ProductInterface = product as ProductInterface
        
        
        const html = await loans.get_schedule_html(obj.product_id, obj.capital, obj.months, obj.fixed_expenses)
        
        set_grid(html)
        
    }
    
    useEffect(() => {
        if(!effect_ran.current) {
            eventEmitter.on(CommonClass.ModalEvents.SetCRInfo, openModal)
        }
        
        return () => {
            effect_ran.current = true
            
            if(!effect_ran.current) {
                eventEmitter.off(CommonClass.ModalEvents.SetCRInfo, openModal)
            }
        }
    }, []);
    
    useEffect(() => {
        if(open && data) {
            schedule_handle()
        }
    }, [open]);
    
    
    return (
        <ModalLayout
            className={st.cr_info_modal}
            open={open}
            innerClassName={st.cr_info_modal_inner}
            on_close_state={() => {
                setInf({})
            }}
        >
            
            {open && (
                <>
                    <strong className={st.strong}>
                        {data?.title || ""}
                    </strong>
                    
                    {grid.length ? (
                        <div className={st.content_container}>
                            <div className={st.content} dangerouslySetInnerHTML={{__html: data.content.replace("{{grid}}", grid)}} />
                        </div>
                    ) : (
                        <div className={st.loading_container}>
                            <CircularProgress color={"success"} />
                        </div>
                    )}
                </>
            )}
        
        </ModalLayout>
    )
}

export default CreditInfoModal